<template>
  <v-card
    class="mx-auto my-12"
    max-width="250px"
    flat
  >
    <v-img
      height="130px"
      :src="data.thumbnails.high.url"
    />

    <v-app-bar
      flat
      dense
      class="justify-space-between" 
    >
      <v-avatar
        size="30"
        dense
      >
        <v-img
          :src="channel.snippet.thumbnails.default.url"
        />
      </v-avatar>

      <v-toolbar-title class="text-subtitle-2 pl-2">
        {{ data.title }}
      </v-toolbar-title>

      <v-spacer />

      <v-btn
        icon
        small
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-app-bar>
  </v-card>  
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: ()=>{return {}}
    },
    channel: {
      type: Object,
      default: ()=>{return {}}
    }
  },
}
</script>